import { render, staticRenderFns } from "./StudentViewer.vue?vue&type=template&id=fcaadbdc&scoped=true&"
import script from "./StudentViewer.vue?vue&type=script&lang=js&"
export * from "./StudentViewer.vue?vue&type=script&lang=js&"
import style0 from "./StudentViewer.vue?vue&type=style&index=0&id=fcaadbdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcaadbdc",
  null
  
)

export default component.exports